export default __webpack_public_path__ + "static/media/logo.b9b358e8.svg";